import { Alert } from "react-bootstrap";
import DefaultSlide from "../../components/Slides/templates/DefaultSlide";
import ImageSlide from "../../components/Slides/templates/ImageSlide";
import TitleSlide from "../../components/Slides/templates/TitleSlide";
import StudentPicker from "../../components/global/StudentPicker";
import { ISlideObject } from "../../components/Slides/templates/ISlideObject";
import CodeSlide from "../../components/Slides/templates/CodeSlide";
import { useEffect, useRef } from "react";
import "./S04P01.css";
import CodePen from "../../components/Codepen/Codepen";

export default function S16P01({ reveal }: ISlideObject) {
  return (
    <>
      <TitleSlide
        title="TI8512 - Desarrollo Ágil de Aplicaciones Web"
        subtitle="Semana 16"
      />
      <DefaultSlide title="Agenda">
        <div style={{ fontSize: "0.75em" }}>
          <ul>
            <li>Repaso del curso + Preguntas</li>
            <li>Seguridad en el desarrollo de aplicaciones web</li>
            <li>Encuesta del curso</li>
            <li>Fin del curso 😊</li>
          </ul>
        </div>
      </DefaultSlide>
      <section>
        <TitleSlide title="Repaso del curso" />
        <DefaultSlide title="¿Qué hemos aprendido en este curso?">
          <div style={{ fontSize: "0.9em" }}>
            <ul>
              <li>Utilicemos la plataforma del developer roadmap <a href="https://github.com/kamranahmedse/developer-roadmap" target="_blank" rel="noopener noreferrer">https://github.com/kamranahmedse/developer-roadmap</a></li>
            </ul>
          </div>
        </DefaultSlide>
      </section>

      <section>
        <TitleSlide title="Seguridad en el desarrollo de aplicaciones web" />
        <DefaultSlide title="¿Por qué es importante la seguridad?">
          <div style={{ fontSize: "0.9em" }}>
            <ul>
              <li>La seguridad es crucial para proteger datos sensibles.</li>
              <li>Las vulnerabilidades pueden llevar a pérdidas financieras y de reputación.</li>
              <li>El desarrollo seguro es una responsabilidad compartida.</li>
            </ul>
          </div>
        </DefaultSlide>
        <section>
          <iframe width="560" height="315" src="https://www.youtube.com/embed/4YOpILi9Oxs?si=PtdDMgC0jaQbzUmF" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </section>
        <DefaultSlide title="Modelo CIA: Confidencialidad, Integridad y Disponibilidad">
          <div style={{ fontSize: "0.9em" }}>
            <ul>
              <li>
                <strong>Confidencialidad:</strong> Garantizar que la información solo sea accesible por personas autorizadas.
              </li>
              <li>
                <strong>Integridad:</strong> Proteger la exactitud y completitud de la información y los métodos de procesamiento.
              </li>
              <li>
                <strong>Disponibilidad:</strong> Asegurar que los usuarios autorizados tengan acceso a la información y recursos cuando lo necesiten.
              </li>
            </ul>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Principios de seguridad">
          <div style={{ fontSize: "0.9em" }}>
            <ul>
              <li>Principio de menor privilegio: otorgar solo los permisos necesarios.</li>
              <li>Validación de entradas: siempre validar y sanitizar datos de entrada.</li>
              <li>Autenticación y autorización: asegurar que los usuarios sean quienes dicen ser.</li>
              <li>Registro y monitoreo: registrar actividades para detectar comportamientos sospechosos.</li>
            </ul>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Prácticas recomendadas">
          <div style={{ fontSize: "0.9em" }}>
            <ul>
              <li>Usar HTTPS para cifrar la comunicación.</li>
              <li>Implementar controles de acceso adecuados.</li>
              <li>Realizar pruebas de penetración y auditorías de seguridad.</li>
              <li>Mantener dependencias y bibliotecas actualizadas.</li>
              <li>Capacitar al equipo en prácticas de seguridad.</li>
            </ul>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Herramientas y recursos">
          <div style={{ fontSize: "0.9em" }}>
            <ul>
              <li>OWASP (Open Web Application Security Project): recursos y guías de seguridad.</li>
              <li>Herramientas de análisis de seguridad como Snyk, SonarQube, y Burp Suite.</li>
              <li>Frameworks de seguridad como Spring Security para Java o Helmet.js para Node.js.</li>
              <li>Documentación y guías de seguridad de los lenguajes y frameworks utilizados.</li>
            </ul>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Ejemplo de vulnerabilidad">
          <div style={{ fontSize: "0.9em" }}>
            <ul>
              <li>Inyección SQL: una vulnerabilidad común donde un atacante puede ejecutar comandos SQL maliciosos.</li>
              <li>Cross-Site Scripting (XSS): permite a un atacante inyectar scripts maliciosos en páginas web vistas por otros usuarios.</li>
              <li>Cross-Site Request Forgery (CSRF): un ataque que engaña a un usuario para que realice acciones no deseadas en una aplicación web en la que está autenticado.</li>
              <li>Falta de autenticación y autorización: permite a un atacante acceder a recursos restringidos.</li>
            </ul>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Seguridad en el desarrollo de aplicaciones web">
          <div style={{ fontSize: "0.9em" }}>
            <ul>
              <li>Principios de seguridad en el desarrollo de software.</li>
              <li>Prácticas recomendadas para proteger aplicaciones web.</li>
              <li>Herramientas y recursos para mejorar la seguridad.</li>
            </ul>
          </div>
        </DefaultSlide>
      </section>

      <section>
        <section><h1>Encuesta</h1></section>
        <section>
          <a href="https://forms.gle/hVkEf442HYEAp3rr7" target="_blank" rel="noopener noreferrer">https://forms.gle/hVkEf442HYEAp3rr7</a>
        </section>
      </section>

      <ImageSlide image="/images/S06/dancing6.gif" title="Fin de la clase" />
    </>
  );
}
